import { c as _c } from "react/compiler-runtime";
import { Button, TextLink } from '@petsmart-ui/sparky';
import type { MouseEvent } from 'react';
import { useAuthSignInClick, useCart, useLogout, useUserSession } from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';
type AccountActionProps = {
  onLinkSelect: () => void;
};
export function AccountAction(t0) {
  const $ = _c(20);
  const {
    onLinkSelect
  } = t0;
  const {
    user,
    userData
  } = useUserSession();
  const {
    isAuth0Enabled,
    handleSignInClick
  } = useAuthSignInClick();
  const {
    clearCart
  } = useCart();
  const logout = useLogout();
  let t1;
  if ($[0] !== user?.gn || $[1] !== userData?.profile?.firstName) {
    t1 = user?.gn?.trim() || userData?.profile?.firstName?.trim() || "";
    $[0] = user?.gn;
    $[1] = userData?.profile?.firstName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const userName = t1;
  let t2;
  if ($[3] !== clearCart || $[4] !== logout || $[5] !== onLinkSelect) {
    t2 = async () => {
      onLinkSelect();
      await logout({
        redirectUrl: "/sign-in",
        callback: clearCart,
        forceRedirect: true
      });
    };
    $[3] = clearCart;
    $[4] = logout;
    $[5] = onLinkSelect;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSignOut = t2;
  let t3;
  if ($[7] !== handleSignInClick || $[8] !== isAuth0Enabled || $[9] !== onLinkSelect) {
    t3 = function handleGuestAccountClick(event) {
      onLinkSelect();
      if (isAuth0Enabled) {
        event.preventDefault();
        handleSignInClick();
      }
    };
    $[7] = handleSignInClick;
    $[8] = isAuth0Enabled;
    $[9] = onLinkSelect;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleGuestAccountClick = t3;
  if (!user) {
    let t4;
    if ($[11] !== handleGuestAccountClick) {
      t4 = <TextLink href={NAVIGATION_URLS.velocity.signIn} className="mobile-menu-quick-links__link mobile-menu-quick-links__link--account" onClick={handleGuestAccountClick}>Sign in or create account</TextLink>;
      $[11] = handleGuestAccountClick;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  let t4;
  if ($[13] !== userName) {
    t4 = userName && <span>Not {userName}? </span>;
    $[13] = userName;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== handleSignOut) {
    t5 = <Button className="mobile-menu-quick-links__sign-out" text="Sign out" type="button" variant="link" onClick={handleSignOut} />;
    $[15] = handleSignOut;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <div className="mobile-menu-quick-links__link">{t4}{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}